import React, {createContext, useEffect, useReducer, useState} from 'react';
import {useRouter} from "next/router";
import {pageview} from "utils/gtag";

type ActionType = { type: 'UPDATE' | 'RESET'; payload: object };

export const SearchContext = createContext<Partial<any>>({});

function reducer(state: any, action: ActionType): any {
    switch (action.type) {
        case 'UPDATE':
            return {...state, ...action.payload};
        case 'RESET':
            return {page: 1};
        default:
            return state;
    }
}

type SearchProviderProps = {
    query: any;
};

export const SearchProvider: React.FunctionComponent<SearchProviderProps> = ({
                                                                                 children,
                                                                                 query,
                                                                             }) => {
    const [state, dispatch] = useReducer(reducer, {...query, page: 1});
    const [search, setSearch] = useState(null);
    const router = useRouter();

    useEffect(() => {
        if (router.query.category || query?.category) {
            setSearch((val) => ({
                ...val,
                category: router.query.category || query?.category
            }));
        }
        if (router.query.text || query?.text) {
            setSearch(val => ({
                ...val,
                text: router.query.text || query?.text
            }));
        }
        if (!router.query?.category && !router.query?.text) setSearch(null);
    }, [router, query]);

    useEffect(() => {
        if (search && search?.text) {
            pageview(`/search?s=${search?.text}`);
        }
    }, [search]);

    return (
        <SearchContext.Provider value={{
            search,
            setSearch,
            state,
            dispatch
        }}>
            {children}
        </SearchContext.Provider>
    );
};
